import axios from 'axios';

import { apiUtil } from '@funnels/utils';

const instance = axios.create();

// Add JWT token to each request
instance.interceptors.request.use((config) => {
  // if config.headers.Authorization is set, this is explicit, e.g. for launchdarkly (see funnels/libs/providers/src/LaunchDarkly/index.tsx)
  config.headers.setAuthorization(config?.headers?.Authorization ?? `Bearer ${apiUtil.getToken()}`);
  config.headers.setContentType('application/json');

  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * no need to capture the header in the error block.
     * Whenever an error occurred here, it navigates to the Error page.
     * see libs/ui-components/src/RouteWithNav/index.tsx
     */
    if (error.response) {
      // Omit error code 499 from Nginx that client closed the connection
      if (error.response.status === 499) {
        return Promise.resolve({ data: { data: [] } });
      }
    } else if (error.request) {
      // The request was made but no response was received
      // can't distinguish between No Internet and client closed the connection
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      return Promise.resolve({ data: { data: [] } });
    }
    throw error;
  }
);

export { instance as axios };
